// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/SchoolDetail.less
// module id = 1627
// module chunks = 0